import React from 'react';
import { useIntl } from 'umi';
import { Bubble, Switch } from 'tea-component';
import { REVENUE_SCOPE_VALUES } from '@intelligence/utils/revenueScope';

interface IRevenueScopeSwitchProps {
  value?: string;
  onChange: (value: string) => void;
}

const RevenueScopeSwitch: React.FC<IRevenueScopeSwitchProps> = ({
  value,
  onChange,
}) => {
  const { formatMessage } = useIntl();
  const isExcluding =
    (value || REVENUE_SCOPE_VALUES.EXCLUDING) ===
    REVENUE_SCOPE_VALUES.EXCLUDING;

  return (
    <div className="compare-pcconsole-filter-switch">
      <Bubble
        dark
        placement="top"
        placementOffset={10}
        style={{ maxWidth: 450 }}
        content={
          <div className="db-tipcontext-content">
            {formatMessage({ id: 'dbi_revenue_scope_tip_excluding' })}
          </div>
        }
      >
        <Switch
          value={isExcluding}
          onChange={(checked) =>
            onChange(
              checked
                ? REVENUE_SCOPE_VALUES.EXCLUDING
                : REVENUE_SCOPE_VALUES.INCLUDING,
            )
          }
        >
          {formatMessage({ id: 'dbi_revenue_scope_exclude_store_fees' })}
        </Switch>
      </Bubble>
    </div>
  );
};

export default RevenueScopeSwitch;
